/**
 * Grainary India — Floating Support Widget Controller
 */
document.addEventListener('DOMContentLoaded', () => {
  const widget = document.getElementById('FloatingSupportWidget');
  const openBtn = document.getElementById('OpenSupportModal');
  const closeBtn = document.getElementById('CloseSupportModal');
  const modal = document.getElementById('FloatingSupportModal');
  const successDone = document.getElementById('SupportSuccessDone');
  const nameInput = document.getElementById('SupportName');

  if (!widget || !openBtn || !modal) return;

  function openSupportModal() {
    widget.classList.add('is-open');
    openBtn.setAttribute('aria-expanded', 'true');
    modal.setAttribute('aria-hidden', 'false');
    if (nameInput) {
      setTimeout(() => nameInput.focus(), 250);
    }
  }

  function closeSupportModal() {
    widget.classList.remove('is-open');
    openBtn.setAttribute('aria-expanded', 'false');
    modal.setAttribute('aria-hidden', 'true');
    openBtn.focus();
  }

  // Toggle button click
  openBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    if (widget.classList.contains('is-open')) {
      closeSupportModal();
    } else {
      openSupportModal();
    }
  });

  // Close button click
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      closeSupportModal();
    });
  }

  // Done button in success state
  if (successDone) {
    successDone.addEventListener('click', () => {
      closeSupportModal();
    });
  }

  // Close when clicking outside of modal & button
  document.addEventListener('click', (e) => {
    if (widget.classList.contains('is-open') && !modal.contains(e.target) && !openBtn.contains(e.target)) {
      closeSupportModal();
    }
  });

  // Close on Escape key press
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && widget.classList.contains('is-open')) {
      closeSupportModal();
    }
  });

  // Auto-open modal if form was posted successfully (e.g. page reloaded by Shopify form post)
  if (document.getElementById('SupportSuccessState')) {
    openSupportModal();
  }
});
